<template>
  <div style="height: calc(100% - 20px); padding-top: 16px">
    <div id="accountManagement" class="fullheight">
      <eco-table
        @load="loadData"
        :data="budget_manager"
        :pageResult="pageResult"
        :selection="true"
        :quick-search-props="[{ prop: 'name', label: '租户名称' }]"
        :show-export="false"
        :show-custom-column="false"
        ref="ecoTable"
      >
        <!-- <template v-slot:search>
        <eco-table-search-panel :divide="3" :label-width="100" ref="adSearch">
          <eco-table-search-field
            label="租户状态"
            prop="tenantStatus"
            :label-width="100"
            operation="EQUAL"
          />
        </eco-table-search-panel>
      </template> -->
        <template>
          <eco-table-column type="index" width="50" align="center" label="序号" />
          <eco-table-column prop="tenantName" label="租户名称" :sortable="true" sort-by="name" :show-overflow-tooltip="true"> </eco-table-column>
          <eco-table-column prop="tenantType" label="租户类型" :sortable="true" sort-by="typeName" :show-overflow-tooltip="true"> </eco-table-column>
          <eco-table-column prop="tenantStatus" label="租户状态" :sortable="true" :show-overflow-tooltip="true"> </eco-table-column>
          <eco-table-column prop="openModules" label="订阅模块" :sortable="false" :show-overflow-tooltip="true"> </eco-table-column>
          <eco-table-column prop="dueModules" label="欠费模块" :sortable="false" :show-overflow-tooltip="true"> </eco-table-column>
          <eco-table-column prop="expireTime" label="模块到期时间" :sortable="false" :show-overflow-tooltip="true"> </eco-table-column>
          <eco-table-column width="180" label="操作">
            <template v-slot="{ row }">
              <el-link type="primary" :underline="false" @click="edit(row)"> 编辑</el-link>
              <!-- <el-dropdown
              size="mini"
              split-button
              @command="handleCommand"
              @click="handleCommand({ row: row, command: 'assignUser' })"
              v-if="row.id != '-1'"
            >
              <span> <i class="el-icon-user"></i>设置管理员 </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-if="row.id != '-1'"
                  icon="el-icon-user"
                  :command="{ row: row, command: 'copyAddress' }"
                  >复制地址</el-dropdown-item
                >
                <el-dropdown-item
                  v-if="
                    (row.id != '-1' && row.status == 'draft') ||
                    row.status == 'disabled'
                  "
                  icon="el-icon-delete"
                  :command="{ row: row, command: 'delete' }"
                  >删除</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
            <el-button
              v-if="row.id == '-1'"
              @click="handleCommand({ row: row, command: 'assignUser' })"
            >
              <span> <i class="el-icon-user"></i>设置管理员 </span>
            </el-button>-->
            </template>
          </eco-table-column>
        </template>
      </eco-table>
    </div>
  </div>
</template>

<script>
import FeTable from '@/components/common/FeTable.vue'
import req from '@/request.js'
export default {
  components: { FeTable },
  data() {
    return {
      budget_manager: [],
      pageResult: {
        page: 1,
        pageSize: 50,
        total: 0
      }
    }
  },
  methods: {
    edit(row) {
      this.$router.push({
        path: '/tenant',
        query: {
          code: row.code,
          id: row.tenantId,
          name: row.tenantName,
          status: row.status
        }
      })
    },
    loadData(param, cb) {
      if (param && cb) {
        const obj = {
          param: param,
          cb: cb
        }
        sessionStorage.setItem('loadJSON', JSON.stringify(obj))
      }
      if (!param) {
        const session = JSON.parse(sessionStorage.getItem('loadJSON'))
        param = session.param
        cb = session.cb
      }

      let url = window.context.third + '/system/account_mangement/query'
      req
        .post(url, param)
        .then((res) => {
          let response = res.data
          this.budget_manager = response.rows
          this.pageResult = {
            page: response.page,
            pageSize: response.pageSize,
            total: response.total
          }
        })
        .finally(() => cb())
    }
  }
}
</script>
